import {gql} from '@apollo/client';

const CREATE_PARTNER = gql`
  mutation createBusPartner(
    $name: String!
    $countryId: ID!
    $mobilityPartnerId: ID
    $depots: [BusPartnerDepotInput]
  ) {
    createBusPartner(
      input: {
        name: $name
        countryId: $countryId
        mobilityPartnerId: $mobilityPartnerId
        depots: $depots
      }
    ) {
      id
      name
      mobilityPartnerId
      countryId
      currency
      status
      source
      depots {
        city
        postCode
        street
      }
    }
  }
`;

export default CREATE_PARTNER;
